var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.19995C8.61929 3.19995 7.5 4.31924 7.5 5.69995C7.5 7.08066 8.61929 8.19995 10 8.19995C11.3807 8.19995 12.5 7.08066 12.5 5.69995C12.5 4.31924 11.3807 3.19995 10 3.19995ZM10 3.19995V1.19995M19 14.1374C16.8012 16.6287 13.5841 18.2 10 18.2C6.41592 18.2 3.19883 16.6287 1 14.1374M8.74483 7.86164L1 21.2M11.2552 7.86164L19 21.2",
    stroke: "#4657F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaas);
export default __webpack_public_path__ + "static/media/baas.14a7a8ca95e66833bf97fe30276ce15e.svg";
export { ForwardRef as ReactComponent };